import { useEffect, useState } from "react";
import { Button, Group, Modal, Paper, Text } from "@mantine/core";
import { ResourceBlame, ResourceForm, useMedplum } from "@medplum/react";
import { normalizeErrorString } from "@medplum/core";
import { useNavigate, useParams } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import PatientTabs from "./Tabs";

export function PatientJson() {
  const medplum = useMedplum();
  const { patientId } = useParams();
  const navigate = useNavigate();
  const [patientDetails, setPatientDetails] = useState<any>({});
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);

  useEffect(() => {
    getPatientDetails();
  }, [medplum]);

  const getPatientDetails = () => {
    medplum.readResource("Patient", `${patientId}`).then((res: any) => {
      setPatientDetails(res);
    });
  };

  const getPatientName = (patientData: []) => {
    let name = "--";
    if (patientData?.length > 0) {
      patientData.forEach((res: any) => {
        if (res?.use === "official") {
          name = res?.text || res?.given[0];
        }
      });
    }
    return name;
  };

  




  return (
    <>
      <PatientTabs
        currentTab={"FHIR Response"}
        patientName={getPatientName(patientDetails?.name)}
        patient={patientDetails}
      />
      <Paper
        sx={{
          padding: "30px",
          borderRadius: "8px",
          margin: "40px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
      >
        <Text style={{ border: "1px solid #ddd", borderRadius: "5px",padding:"12px" }}>
          <pre>{JSON.stringify(patientDetails, null, 2)}</pre>
        </Text>

        {/* <ResourceBlame resourceType="Patient" id={patientId} /> */}
      </Paper>
    </>
  );
}
